import { subscriptionStore } from './subscription.store';
import { formatExpiryInPT } from './use-plus-offer-label';

export interface PowerOfferOption {
  interval: 'monthly' | 'annual';
  name: string;
  discountLabel: string;
  confirmDescription: string;
}

export interface PowerOfferLabel {
  ctaLabel: string;
  expiryLabel: string;
  options: PowerOfferOption[];
}

export function usePowerOfferLabel(): PowerOfferLabel | null {
  const offer = subscriptionStore.state.powerUpgradeOffer;
  if (!offer) return null;

  const expiresAt = new Date(offer.expiresAt);
  if (Number.isNaN(expiresAt.getTime()) || expiresAt <= new Date()) {
    return null;
  }

  return {
    ctaLabel: 'Upgrade to Power',
    expiryLabel: formatExpiryInPT(expiresAt),
    options: [
      {
        interval: 'monthly',
        name: 'Monthly',
        discountLabel: '50% off for 2 months',
        confirmDescription:
          'Your Plus subscription switches to Power monthly right away, with 50% off your first 2 months.',
      },
      {
        interval: 'annual',
        name: 'Annual',
        discountLabel: '$50 off your first year',
        confirmDescription:
          'Your Plus subscription switches to Power annual right away, with $50 off your first year.',
      },
    ],
  };
}
